module.exports = __webpack_public_path__ + "static/media/27.bffd8c92.mp3";